import React from "react";
import _ from "lodash";
import { Routes, Route } from "react-router-dom";
import ProductContext from "src/contexts/product/productContext";
import ProductRegister from "src/pages/product/register/index";

const Public = () => {
  const data = [
    {
      path: "/me",
      component: (
        <ProductContext>
          <ProductRegister />
        </ProductContext>
      ),
    },
  ];
  return (
    <Routes>
      {_.map(data, (el) => {
        return (
          <Route key={el.path} exact path={el.path} element={el.component} />
        );
      })}
    </Routes>
  );
};

export default React.memo(Public);
